module.exports = __webpack_public_path__ + "static/media/step-4-card.f87e280b.png";